import React, { useEffect, useState } from 'react'
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import axiosInstance from '../../../../Services/axiosCommon';
import { NormalHeading } from '../../../../Components/Utils/Heading';
import CommonComments from '../../../../Components/Utils/commonComments';
import FilesView from '../../../../Components/Utils/FilesView';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { GetAccess } from '../../../../Components/Utils/roles';

function ViewSupplier() {
 const { suppliersViewId } = useParams();
     const location = useLocation();
     const cdata = location.state?.data;
           const pageIndex = location.state?.pageIndex;
           const searchQuery = location.state?.searchQuery;
           
           const [data,setData] = useState(cdata? cdata:null); 
     const [percentOpen, setPercentOpen] = useState(false);
      const [createNew, setCreateNew] = useState({
       name:""
     });
     const [expandedIndex, setExpandedIndex] = useState(null);
   
     const handleToggle = (index) => {
       setExpandedIndex(expandedIndex === index ? null : index);
     };
  
     const [filePathList, setFilePathList] = useState([]);
    useEffect(() => {
      if (
        data?.attachments !== null &&
        data?.attachments !== "None" &&
        data?.attachments !== "[]"
      ) {
        setFilePathList(data?.attachments?.length>0 ? data?.attachments : []);
      }
    }, [data]);

    function getView() {
      axiosInstance 
        .get(`/suppliers/${suppliersViewId}`)
        .then((res) => {
          setData(res.data?.data);       
        })
        .catch(err=>{
          console.log("err", err);
        })
    }
    
    useEffect(() => {
      // if (!cdata) {
        getView();
      // }
    }, [])
  
  
     
     const formik = useFormik({
       enableReinitialize: true,
       initialValues: createNew,
       validateOnChange: false,
       validateOnBlur: false,
      
       onSubmit: (values) => console.log("Form Submitted", values),
     });
     
     return (
       <div className="w-full h-full py-2 px-4 ">
         <div className="sm:flex justify-between ">
         <Breadcrumb
                  items={[
                    // { name: "Contacts" },
                    {
                      name: "Supplier",
                      link:"/contacts/suppliers"

                     
                    },
        
                    { name: "View" },
                  ]}
                />
           <div className=" flex gap-2 justify-end">
             <Link
               to={`/contacts/suppliers`}
               state={{
                 currentPage: pageIndex,
                 searchQuery: searchQuery != "" ? searchQuery : "",
               }}
             >
               <BackButton link={true} />
             </Link>
             {GetAccess("suppliers_edit")&&
             <Link
               to={`/contacts/suppliers/edit/${suppliersViewId}`}
               state={{
                 data: data,
                 from: `/contacts/suppliers/view/${suppliersViewId}`,
               }}
             >
               <EditButton height="8" />
             </Link>
             }
           </div>
         </div>
   
         <div className="w-full mx-auto h-[calc(100vh-160px)] drop-shadow-lg overflow-y-auto mt-4  md:flex gap-x-2 text-[#111537]">
           <div className="lg:w-[70%] md:w-[60%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
             <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
              <div className='flex gap-4'>
             <div className='w-16 bg-slate-50  2xl:w-20  h-16 2xl:h-20 flex justify-center items-center rounded-md border-2  border-baseColor-secondary bg-basColor-quartary border-solid overflow-hidden'>
            {/* <img className='w-full h-auto' src={data?.vendorImage?.file} alt='' /> */}
            {
  data?.vendorImage?.file ? (
    <img
      src={data.vendorImage.file}
      alt="Vendor"
      className="object-cover"
    />
  ) : (
    <span className="uppercase">
      {data?.companyName?.charAt(0)?.toUpperCase()}
    </span>
  )
}

          </div>
          <div className="grid  items-center ">
               <div className=" mb-1 text-[#111537] font-semibold w-[100%]">
                 <p className="flex text-lg">{data?.companyName}</p>
                 <p className="flex text-[#606279] text-xs">{data?.refNumber}</p>

               </div> 
               {/* <div className="flex gap-4 justify-between">
                 <p className="text-xs text-[#111537]">Date : 05-03-2025</p>
               </div> */}
             </div>
               </div>
   
               <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
                            <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                              Status{" "}
                            </div>
                            <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                              {data?.vendorStatus || "-"}
                            </div>
                          </div>
             </div>
   
             <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
               <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
                {/* {data?.image.file && (
          <div className='w-20 mt-3 h-20 flex justify-center items-center rounded-full border-2  border-baseColor-secondary bg-basColor-quartary border-solid overflow-hidden'>
              <img className='w-full h-auto' src={data?.image?.file} alt='employee' />
            </div>
            )} */}
                 <div className=" w-full sm:grid grid-cols-2 gap-x-8 mt-3">
                  
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Category
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.category}
                     </p>
                   </div>
                  
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Type
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.vendorType}
                     </p>
                   </div>
   
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Phone
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.phoneWithCC}
                     </p>
                   </div>
   
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Email
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.email}
                     </p>
                   </div>
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Website
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.website}
                     </p>
                   </div>
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Tax Id
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.taxId}
                     </p>
                   </div>
                   {/* <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Currency
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.currencyId}
                     </p>
                   </div> */}
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Payment Terms
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.paymentTerms}
                     </p>
                   </div>
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Deliver Terms
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.deliverTerms}
                     </p>
                   </div>
                   <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Rating
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       : {data?.performanceRating}
                     </p>
                   </div>
                  
                   {/* <div className="w-full flex px-2">
                     <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                       Inspection Date
                     </p>
                     <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                       :{" "}
                       {data?.inspectionDate ? (
                         <NuDate
                           value={data?.inspectionDate}
                           format="DD-MMM-YYYY"
                         />
                       ) : (
                         "N/A"
                       )}
                     </p>
                   </div> */}
                 </div>
               </div>
               <div className='sm:flex gap-4 mt-4'>

               <div className="sm:w-[50%]">
  <p className="text-xs font-medium text-[#111537] p-1">Address</p>

  <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
   
  <div className="text-xs p-2 leading-snug">
  <p>
    {[data?.address1, data?.address2].filter(Boolean).join(', ')}
  </p>
  <p>
    {[data?.city, data?.state, data?.postalCode, data?.country]
      .filter(Boolean)
      .join(', ')}
  </p>
</div>


    
  </div>
</div>
               {/* <div className="sm:w-[50%] ">
                  <p className=" p-1 text-xs font-medium text-[#111537]">
                    Attachement
                  </p>
                  <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                    <SmallHeading title={"PR Attachments"} />
  
                    <div className="w-full flex gap-2 flex-wrap ">
                      {data?.attachments &&
                        filePathList.map((imgs, idx) => {
                          console.log("img", imgs);
                          return (
                            <FilesView fileView={imgs} key={idx} />
                          );
                        })}
                    </div>
                  </div>
                </div> */}
                <div className="sm:w-[50%] ">
                   <p className="  text-xs font-medium text-[#111537] p-1">
                     Comments
                   </p>
                   <div className="  border border-gary  h-28 overflow-y-scroll rounded-lg items-center">
                     <p className="  text-xs p-2 break-words text-[#606279]">
                       {data?.comments || "-"}
                     </p>
                   </div>
                 </div>
                 </div>
               {/* <div className="w-full bg-white border border-gray-300 mt-4 rounded-lg">
         <div className="w-full py-[1%] bg-baseColor-primary flex justify-between rounded-lg px-3">
           <p className="w-[55%] text-left text-white text-xs font-medium">Forms</p>
           <p className="w-[10%] text-center text-white text-xs font-medium">Updated On</p>
           <p className="w-[15%] text-center text-white text-xs font-medium">Process</p>
           <p className="w-[15%] text-center text-white text-xs font-medium">Status</p>
         </div>
   
         {formInputs?.map((form, index) => (
           <React.Fragment key={index}>
             <div
               className="w-full py-2 flex justify-between items-center odd:bg-white even:bg-slate-100 px-3"
             >
               <div
                 className="w-3 rounded-md cursor-pointer text-center p-0.5"
                 onClick={() => handleToggle(index)}
               >
                 {expandedIndex === index ? <ToggleUp /> : <ToggleDown />}
               </div>
   
               <p className="w-[55%] text-left text-xs font-medium text-[#111537]">
                 {form?.title}
               </p>
   
               <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
                 {form?.updatedOn}
               </p>
   
               <div className="w-[15%] py-2 text-xs text-center font-normal text-mainColor-400">
                 <Progress
                   type="circle"
                   size={30}
                   strokeWidth={12}
                   format={(percent) => (
                     <p
                       className={`cursor-pointer ${
                         form?.completion > 95
                           ? "text-[#87d068]"
                           : form?.completion > 50
                           ? "text-[#108ee9]"
                           : "text-[#D2BD00]"
                       } text-xs font-semibold`}
                     >
                       {percent}
                     </p>
                   )}
                   percent={Math.floor(form?.completion) || 0}
                   strokeColor={
                     form?.completion > 95
                       ? { "0%": "#87d068", "100%": "#87d068" }
                       : form?.completion > 50
                       ? { "0%": "#108ee9", "100%": "#108ee9" }
                       : { "0%": "#D2BD00", "100%": "#D2BD00" }
                   }
                 />
               </div>
   
               <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                 {form?.status}
               </p>
             </div>
   
             {expandedIndex === index && (
               <div className="bg-white p-4 border-t border-gray-200">
                 <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
                    <div className="mb-6">
                     <h3 className="text-xs font-semibold mb-4">CLIENT DETAILS :</h3>
                     <div className="flex flex-wrap -mx-2">
                       {form.formInputs.slice(0, 6).map((input, idx) => (
                         <MainFormInput key={idx} formInput={input} formik={formik} />
                       ))}
                     </div>
                   </div>
   
                     <div className="mb-6">
                     <h3 className="text-xs font-semibold mb-4">INSPECTION DETAILS :</h3>
                     <div className="flex flex-wrap -mx-2">
                       {form.formInputs.slice(6, 10).map((input, idx) => (
                         <MainFormInput key={idx} formInput={input} formik={formik} />
                       ))}
                     </div>
                   </div>
   
                      {/* <div className="mb-6">
                     <h3 className="text-xs font-semibold mb-4">INSPECTION & SERVICE TYPE :</h3>
                     <div className="flex flex-wrap -mx-2">
                       {form.formInputs.slice(10, 13).map((input, idx) => (
                         <MainFormInput key={idx} formInput={input} formik={formik} />
                       ))}
                     </div>
                   </div> */}
   
                    {/* <div className="mb-6">
                     <h3 className="text-xs font-semibold mb-4">OBSERVATION :</h3>
                     <div className="flex flex-wrap -mx-2">
                       {form.formInputs.slice(13).map((input, idx) => (
                         <MainFormInput key={idx} formInput={input} formik={formik} />
                       ))}
                     </div>
                   </div>
   
                   <div className="flex items-center justify-end px-6 py-6 rounded-b text-xs 2xl:text-sm">
                     <button
                       type="button"
                       onClick={onClose}
                       className="bg-text hover:shadow-menu text-white px-6 py-2 mr-2 rounded-3xl"
                     >
                       Cancel
                     </button>
                     <button
                       type="submit"
                       className="bg-primary hover:shadow-button text-white px-6 py-2 rounded-3xl"
                     >
                       Submit
                     </button>
                   </div>
                 </form>
               </div>
             )}
           </React.Fragment>
         ))}
       </div>  */}
   
   
             </div>
           </div>
           <div className="lg:w-[30%] md:w-[40%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
             <div className="h-[98%] overflow-y-scroll p-2 ">
               <div className="w-full grid  border border-gary   rounded-lg">
                 <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                   <p className="text-xs text-white font-medium">Primary Contact</p>
                 </div>
                 {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}
   
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     Name
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     : {data?.pcName}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Designation
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.pcDesignation}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Mobile
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.pcMobile}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Email
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.pcEmail}
                   </p>
                 </div>
               </div>

               {(data?.scName || data?.scDesignation || data?.scMobile || data?.scEmail) && (

               <div className="w-full grid  border border-gary   rounded-lg mt-2">
                 <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                   <p className="text-xs text-white font-medium">Secondary Contact</p>
                 </div>
                 {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}
   
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     Name
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     : {data?.scName}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Designation
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.scDesignation}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Mobile
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.scMobile}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Email
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.scEmail}
                   </p>
                 </div>
               </div>
               )}
 
               {/* <div className="w-full grid  border border-gary mt-2   rounded-lg">
                 <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                   <p className="text-xs text-white font-medium">Address</p>
                 </div>
   
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                   Street Address 1
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     : {data?.address1}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Street Address 2
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.address2}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     City
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.city}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     State
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.state}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Postal Code
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.postalCode}
                   </p>
                 </div>
                 <div className="w-full flex px-2 justify-between">
                   <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                     {" "}
                     Country
                   </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                     {" "}
                     : {data?.country}
                   </p>
                 </div>
               </div> */}
   
               {/* <div className="w-full grid  border border-gary mt-4  rounded-lg ">
                 <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                   Forms{" "}
                 </p>
                 <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                   <div
                     onClick={[]}
                     className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                   >
                     <svg
                       width="20"
                       height="20"
                       fill="#3369ff"
                       xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 512 512"
                     >
                       <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                     </svg>
                     <p className="w-auto text-[10px]">
                       {data?.ref || "Survey form"}
                     </p>
                   </div>
                 </div>
               </div> */}
   
               {/* <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
                 <CommonComments
                   visible={true}
                   title="Comments"
                   mainId={data?.prId}
                   addurl={"/pr-comments/new-comment"}
                   geturl={`/pr-comments/by-PR/${data?.prId}`}
                 />
               </div> */}
             </div>
           </div>
         </div>
       </div>
     );
}

export default ViewSupplier;


